import type { TagType } from '../../review/types/ReviewableType';

export const getPhotoCardBadges = (card: any): string[] => {
  const badges: string[] = [];

  if (card?.distributors && Array.isArray(card.distributors)) {
    badges.push(...card.distributors.map((distributor: TagType) => distributor.name));
  }
  if (card?.tags && Array.isArray(card.tags)) {
    badges.push(...card.tags.map((tag: TagType) => tag.name));
  }
  if (card?.meta?.polaroid) {
    badges.push('POLAROID');
  }
  if (card?.meta?.unit) {
    badges.push('UNIT');
  }
  return badges;
};
